// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"aa7b5b5b","459":"d5a28be3","743":"73cebb1c","767":"73f3898f","993":"73cebb1c"}[chunkId] + ".css";
};